import { useLinking } from '~global/hooks';
export const footer = {
  payments: [
    [
      {
        uri: require('~assets/img/home/footer/Visa-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/Mastercard-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/JCB-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/BNI-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/Mandiri-payment-logo.png'),
      },
    ],
    [
      {
        uri: require('~assets/img/home/footer/BRI-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/Digibank-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/BCA-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/AmericanExpress-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/OVO-payment-logo.png'),
      },
    ],
    [
      // {
      //   uri: require('~assets/img/home/footer/tcash-payment-logo.png'),
      // },
      // {
      //   uri: require('~assets/img/home/footer/VOSPAY-payment-logo.png'),
      // },
      {
        uri: require('~assets/img/home/footer/GOPAY-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/UOB-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/Panin-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/Indomaret-payment-logo.png'),
      },
      {
        uri: require('~assets/img/home/footer/Atome-payment-logo.png'),
      },
    ],
    [
      {
        uri: require('~assets/img/home/footer/shopeepay-payment-logo.png'),
      },
    ],
  ],
  links: {
    web: [
      { name: 'About Us', screen: 'AboutUsScreen', key: 'about-us' },
      { name: 'Contact Us', screen: 'ContactUsInfoScreen', key: 'contact-us' },
      {
        name: 'Terms & Conditions',
        screen: 'TermsAndConditionScreen',
        key: 'terms-and-conditions',
      },
      {
        name: 'Privacy Policy',
        screen: 'PrivacyPolicyScreen',
        key: 'privacy-policy',
      },
      {
        name: 'Business Partner',
        screen: 'AffiliateWithUsScreen',
        key: 'affiliate-with-us',
      },
      { name: 'Careers', screen: 'CareersScreen', key: 'careers' },
      { name: 'Our Store', screen: 'StoreScreen', key: 'stores' },
    ],
    mobileWeb: [
      { name: 'About Us', screen: 'AboutUsScreen', key: 'about-us', dot: true },
      {
        name: 'Contact Us',
        screen: 'ContactUsInfoScreen',
        key: 'contact-us',
        dot: true,
      },

      { name: 'Careers', screen: 'CareersScreen', key: 'careers', dot: true },
      {
        name: 'Privacy Policy',
        screen: 'PrivacyPolicyScreen',
        key: 'privacy-policy',
        dot: false,
      },
      {
        name: 'Terms & Conditions',
        screen: 'TermsAndConditionScreen',
        key: 'terms-and-conditions',
        dot: true,
      },
      {
        name: 'Business Partner',
        screen: 'AffiliateWithUsScreen',
        key: 'affiliate-with-us',
        dot: false,
      },
    ],
  },
  services: [
    {
      name: ['Email', 'cs@lilla.id'],
      link: 'mailto:cs@lilla.id',
      key: 'email',
      dot: true,
      useLinking,
    },
    {
      name: ['Whatsapp', '08111458788'],
      link: 'https://wa.me/628111458788',
      key: 'chat',
      dot: true,
      useLinking,
    },
    {
      name: ['Help Center'],
      screen: 'HelpScreen',
      key: 'help-center',
      dot: false,
    },
  ],
  socials: [
    { key: 'facebook', uri: require('~assets/img/home/icon-facebook.png') },
    { key: 'instagram', uri: require('~assets/img/home/icon-instagram.png') },
    { key: 'line', uri: require('~assets/img/home/icon-line.png') },
    { key: 'whatsapp', uri: require('~assets/img/home/icon-whatsapp.png') },
  ],
  socialsWeb: [
    {
      key: 'facebook',
      uri: require('~assets/img/home/footer/icon-facebook.svg'),
    },
    {
      key: 'instagram',
      uri: require('~assets/img/home/footer/icon-instagram.svg'),
    },
    { key: 'line', uri: require('~assets/img/home/footer/icon-line.svg') },
    {
      key: 'whatsapp',
      uri: require('~assets/img/home/footer/icon-whatsapp.svg'),
    },
  ],
  contactLinks: [
    {
      title: 'Email',
      text: 'cs@lilla.id',
      link: 'mailto:cs@lilla.id',
      source: require('~assets/img/header/top-mail.svg'),
      useLinking,
    },
    {
      title: 'Whatsapp',
      text: '08111458788',
      link: 'https://wa.me/628111458788',
      source: require('~assets/img/header/top-whatsapp.svg'),
      useLinking,
    },
    {
      title: 'Line',
      text: '@lilla.id',
      link: '',
      source: require('~assets/img/header/top-line.svg'),
      useLinking: () => {},
    },
  ],
  safetyConsumers: {
    title: 'Direktorat Jenderal Perlindungan \nKonsumen dan Tertib Niaga',
    titleMobile: 'Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga',
    subTitle: '(WhatsApp)',
    contact: '0853-1111-1010',
    link: 'https://wa.me/6285311111010',
    useLinking,
  },
  customerCareConsumers: {
    title: 'Layanan Pengaduan Konsumen',
    subTitle: 'PT Sociolla Ritel Indonesia',
  },
};

export const footerTopLogo = require('~assets/img/home/footer/footer-top-logo.svg');
export const footerTopBg = require('~assets/img/home/footer/footer-top-bg.svg');
export const footerTopText = require('~assets/img/home/footer/footer-top-text.svg');
export const footerBarcode = require('~assets/img/home/footer/footer-barcode.svg');
export const footerLogoSmall = require('~assets/img/home/footer/logo-sm.svg');
